import Img from '../components/Img';
import React from 'react';
import './OurProcess.css';
import { Helmet } from '@dr.pogodin/react-helmet';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const OurProcess: React.FC = () => {
  return (
    <>
    <Helmet>
      <title>Our Process | Atomic Tattoo Removal</title>
      <meta name="description" content="Discover the tattoo removal process at Atomic Tattoo Removal. We use advanced laser technology for safe and effective tattoo removal." />
      <meta name="keywords" content="tattoo removal process, laser tattoo removal, safe tattoo removal, Wrentham MA, Franklin MA, Foxboro MA, Norfolk County MA, professional tattoo removal" />
      <meta property="og:title" content="Our Process | Atomic Tattoo Removal" />
      <meta property="og:description" content="Discover the tattoo removal process at Atomic Tattoo Removal. We use advanced laser technology for safe and effective tattoo removal." />
      <meta property="og:image" content="https://www.atomictattooremoval.com/assets/woman-raygun-pink-circle.png" />
      <meta property="og:url" content="https://www.atomictattooremoval.com/our-process" />
    </Helmet>
    <div className="our-process">
    <div className="image image-top">
        <Img src="/assets/woman-raygun-pink-circle.png" alt="Woman with raygun - tattoo removal" />
      </div>

      <div className="text text-top">
        <h1>How Laser Tattoo Removal Works</h1>
        <p>
        The Astanza Trinity emits ultra-short pulses of light energy that penetrate the skin and break down tattoo ink particles. These particles are then naturally eliminated by your body's immune system over time. Multiple sessions are typically required, spaced several weeks apart, to achieve optimal results. 
        <br/><br/>From stubborn reds and vibrant blues to deep blacks and pastels, we’re equipped to fully remove even the most colorful tattoos, safely and effectively.
        Our process is personalized, transparent, and focused on your comfort from start to finish. Whether you're removing a name, sleeve, or small symbol, we tailor every step to your skin type, tattoo size, and fading goals.

        <h3>What to Expect During Treatment</h3>
        ✅ <b>Consultation:</b> We'll assess your tattoo and discuss your goals to create a customized treatment plan.
        <br/>
        ✅ <b>Treatment Sessions:</b> Each session lasts between 10 to 30 minutes, depending on the size and complexity of the tattoo.
        <br/>
        ✅ <b>Aftercare:</b> Post-treatment care includes keeping the area clean and protected. We'll provide detailed aftercare instructions to ensure proper healing.
        <br/><br/>
        <Link to="/book-consultation" style={{ textDecoration: 'none' }}>           
        <Button color="secondary"
          variant="contained"
          onClick={() => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'book_now_click',
              button_location: 'our_process_page_top', 
            });
          }}
          sx={{ 
            color: '#f0e9d4', 
            '&:hover': { color:'#ffffff',backgroundColor:'#cb4f2e' } }}
          >
          👉 Book Your Free Consultation
        </Button>  
      </Link> 
       </p>
      </div>

    </div>
    <div className="our-process">
      <div className="image image-bottom">
        <Img src="/assets/man-raygun-blue-circle.png" alt="Man with raygun - tattoo removal" />
      </div>
      <div className="text text-bottom">
        <h2>Why Choose Atomic Tattoo Removal?</h2>
        <p>

✅ <b>Experience Professionals:</b> Our certified technicians are trained in the latest laser removal techniques.
<br/>
✅ <b>Personalized Care:</b> We tailor each treatment plan to your specific needs and skin type.
<br/>
✅<b>Comfort & Safety:</b> Your comfort and safety are our top priorities throughout the removal process.
<br/>
<br/>
Ready to take the next step? Contact us today to schedule your free consultation!
<br/>
<br />
<Link to="/book-consultation" style={{ textDecoration: 'none' }}>           
        <Button color="secondary"
          variant="contained"
          onClick={() => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'book_now_click',
              button_location: 'our_process_page_bottom', 
            });
          }}
          sx={{ 
            color: '#f0e9d4', 
            '&:hover': { color:'#ffffff',backgroundColor:'#cb4f2e' } }}
          >
          👉 Book Your Free Consultation
        </Button>  
      </Link> 
        </p>
      </div>
    </div>
    <div
  style={{backgroundColor: '#5C96AC',padding: '20px', margin: '0'}}
>
      <Img src="/assets/how-it-works.png" alt="How tattoo removal works" className="how-it-works" />
    </div>
    </>
  );
};

export default OurProcess;